// note: this logic is duplicated in the mobile app because of deadline reasons
// a refacto will be lead to put all referral related logic in a the referrals-service

import differenceInDays from 'date-fns/differenceInDays';

// Marketing team is launching a special offer on referral to reward referrer
// by 125€ instead of 100€. This offer is valid from 15/01/2024 to 10/03/2024.
export const isDuringSpecialOffer = (date: Date) => {
  return (
    date > new Date('2024-01-15 08:00:00+1:00') &&
    date < new Date('2024-03-10 24:00:00+1:00')
  );
};

export const daysBeforeEndOfOffer = () => {
  const endOfOfferDate = new Date('2024-03-10 24:00:00+1:00');
  return differenceInDays(endOfOfferDate, new Date());
};

export const referrerRewardAmount = (date: Date) => {
  // Before the 25/01/2022, the referrer reward was 25€
  if (date < new Date('2022-01-25 00:00:00+1:00')) {
    return 25;
  }

  if (isDuringSpecialOffer(date)) {
    return 125;
  }

  return 100;
};
